/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from '../config/featuresSection.config.json';
import { VApplication } from "../../../application";

import { toHeaderCase } from 'js-convert-case';

export interface IFormatBadeDetailMethods extends IPluginMethodMap {
  getFormatBadeDetailSync(args: any): any;
}

export class FormatBadeDetailService implements IAgentPlugin {
  readonly methods: IFormatBadeDetailMethods;

  constructor() {
    this.methods = {
      getFormatBadeDetailSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    console.log(`args in badge detail :`, args)
    return {
      productData: {
        title: toHeaderCase(args?.badgeName ?? ""),
        subtitle: args?.description,
        backArrow: true,
        heroImage: {
          title: args?.badgeName,
          align: "top",
          image: args?.images && Array.isArray(args?.images) && args?.images.length > 0 ? args?.images[0] : "https://i.ibb.co/WBztXW5/organic-logo-removebg-preview.png"
        },
        buttons: this.getButtons(args?.buttons),
        carouselItems: this.getCarousel([...args?.evidences]),
        carouselStyles: config?.carouselStyles,
        accordionItems: this.getAccordionItems(args),
        badgeCarouselItems: this.getBadgeCarousel(args?.credentials),
        TIME_LINE_ITEMS: this.getTimeLine(args?.provenance),
      }
    };
  }

  private getCarousel(data: any) {
    let _tmp = Array.isArray(data) && data?.map(item => {
      let _formatter = item && item.split(".")
      _formatter = _formatter.at(-1)
      if (_formatter === "pdf") {
        return {
          type: "pdf",
          src: item?.docUri ?? item,
          title: item?.title ?? "Evidences",
        };
      } else {
        return ({
          // ...item,
          type: "img",
          src: item,
          poster: item
        })
      }
    });
    return _tmp;
  }

  private getTimeLine(data: any) {
    let _temp: any = [];
    Array.isArray(data) && data?.forEach(element => {
      _temp.push(
        {
          "key": element?._id,
          "headline": toHeaderCase(element?.name ?? ""),
          "headlineBackgroundColor": "#579783",
          "children": this.getChildren(element)
        }
      )
    });

    return _temp;
  }

  private getChildren(data: any) {
    let _temp: any = [];
    _temp.push({
      provenanceItem: data,
      "itemId": data?.provenanceId,
      "title": data?.name,
      "subtitle": data?.description,
      "carouselItems": data?.media?.length > 0 ? [...data?.media] : null,
      "carouselStyles": {
        "width": "250px",
        "height": "250px"
      },
      "badgeCarouselItems": this.getBadgeCarousel(data?.credentials)
    });

    Array.isArray(data?.subSteps) && data?.subSteps.forEach(ele => {
      _temp.push({
        provenanceItem: ele,
        "itemId": ele?.provenanceId,
        "title": ele?.name,
        "subtitle": ele?.description,
        "carouselItems": ele?.media?.length > 0 ? [...ele?.media] : null,
        "carouselStyles": {
          "width": "250px",
          "height": "250px"
        },
        "badgeCarouselItems": this.getBadgeCarousel(ele?.credentials)
      })
    });

    return _temp;
  }

  private getBadgeCarousel(data: any) {
    let _temp: any = [];
    Array.isArray(data) && data.forEach(element => {
      _temp.push({
        batchData: element,
        key: element?.batchId,
        titleImage: element?.logo,
        title: element?.name
      });
    });

    return _temp;
  }

  private getAccordionItems(res: any) {
    let _temp = [];
    if (res?.description) {
      _temp.push({
        type: "text",
        title: "Description",
        "data": [
          res?.description
        ]
      })
    }
    if (res?.org) {
      let _list: any = [];
      let _org = { ...res?.org };
      delete _org._id;
      delete _org.id;
      delete _org.phones;
      delete _org.socialLinks;
      let _social = Array.isArray(res?.org?.socialLinks) && res?.org?.socialLinks?.map(item => {
        return ({
          title: toHeaderCase(item?.type ?? ""),
          subTitle: item?.url,
          link: item?.url
        });
      })
      for (const [key, value] of Object.entries(_org)) {
        _list.push({
          title: toHeaderCase(key ?? ""),
          subTitle: value
        })
      }
      _temp.push({
        "type": "multi-col-list",
        "title": "Organization",
        "numberOfColumns": "3",
        data: [..._list, ..._social]
      })
    }
    if (res?.badgeInfoList && res?.badgeInfoList?.length > 0) {
      let _list: any = [];
      Array.isArray(res?.badgeInfoList) && res?.badgeInfoList.forEach((ele: any) => {
        _list.push({
          ...ele,
          title: toHeaderCase(ele?.label ?? ""),
          subTitle: ele?.value
        })
      });
      _temp.push({
        "type": "multi-col-list",
        "title": "Badge Details",
        "numberOfColumns": "3",
        data: [..._list]
      })
    }
    if (res?.blockchainProof && res?.blockchainProof?.length > 0) {
      let _list: any = [];
      Array.isArray(res?.blockchainProof) && res?.blockchainProof.forEach((ele: any) => {
        _list.push({
          ...ele,
        })
      });
      _temp.push({
        "type": "multi-col-list",
        "title": "Blockchain Proof",
        "numberOfColumns": "3",
        data: [..._list]
      })
    }
    return _temp;
  }

  private getButtons(data: any) {
    let buttonColor = ["primary", "secondary", "tertiary"];
    let _buttons = Array.isArray(data) && data?.map((item, index) => {
      return ({
        ...item,
        key: `${item?.label}-${index}`,
        title: item?.name,
      });
    });
    return _buttons;
  }
}
